/* eslint-disable react-hooks/exhaustive-deps */
import {
  isFunction,
  each,
  get,
  isArray,
  isEmpty,
  isEqual,
  isString,
} from "lodash";
import {
  useCallback,
  useEffect,
  useState

} from "react";
import { testMsg } from "../test-apis";
import {
  isTestCompany
} from "../utils/auth";
import {
  getFieldByKey
} from "../utils/dataComponent";
import {
  setIn
} from "../utils/setIn";
// import systemAlert from "../utils/systemAlert";
import {
  transform,
  getValidatorErros,
  isValid,
  restore
} from "../utils/validator";

const useForm = (
  initForm = {},
  onSubmit = () => { },
  validator = () => {
    return {};
  },
  fields = []
) => {
  const [submit, _setSubmit] = useState(null);

  const [form, setForm] = useState(initForm);
  const [originForm, setOriginForm] = useState(initForm);
  const [errors, setErrors] = useState({});
  const [isSubmit, setIsSubmit] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [isError, setIsError] = useState(false);
  const [validateFields, setValidateFields] = useState(fields);
  const [isHandleSubmit, setIsHandleSubmit] = useState(false);

  // LIST 용
  const [list, setList] = useState([]);
  const [selectedList, setSelectedList] = useState([]);
  const [selectedData, setSelectedData] = useState({});
  const [total, setTotal] = useState(0);
  const [isLoading, setIsLoading] = useState(false);

  const setSubmit = (_submit) => {
    _setSubmit(() => _submit);
  };

  const handleOnChange = (event) => {
    if (event.target) {
      const {
        name,
        value
      } = event.target;
      setInForm(name, value);
    } else {
      // event = {[key]:value,[key]:value,[key]:value}
      _setForm(event);
    }
  };

  const _setForm = (__form) => {
    let _form = form;
    each(__form, (value, key) => {
      const field = getFieldByKey(validateFields, key);
      if (field && field.validators) {
        value = transform(value, field.validators);
      }
      _form = setIn(_form, key, value);
    });
    setForm({
      ..._form
    });
  };

  // useEffect(() => {
  //   if (process.env.REACT_APP_MODE === 'dev') {
  //     console.log('[useForm.js] CHAGNE FORM : ', form);
  //   }
  // }, [form]);

  const setInForm = useCallback((name, value) => {
    _setForm(setIn(form, name, value));
  }, [form]);
  // const setInForm = useCallback((name, value) => {
  //   _setForm({
  //     ...form,
  //     [name]: value
  //   })
  // }, []);

  const __validator = (form, field, errors = {}) => {
    if (!field.key) return;
    if (isEmpty(errors[field.key])) {
      errors[field.key] = [];
    } else if (isString(errors[field.key])) {
      errors[field.key] = [errors[field.key]];
    }
    const value = get(form, field.key);
    if (field.required && !isValid(value, 'required')) {
      getValidatorErros(value, 'required', field.title || field.label, errors[field.key]);
    }
    if ((field.required || value) && field.min && value.length < field.min) {
      errors[field.key].push(`${field.title || field.label}은(는) 최소 ${field.min}자리 입니다.`);
    }
    if ((field.required || value) && field.max && value.length < field.max) {
      errors[field.key].push(`${field.title || field.label}은(는) 최대 ${field.max}자리 입니다.`);
    }
    if (field.validators && (isString(field.title) ? field.title : field.label)) {
      getValidatorErros(value, field.validators, (isString(field.title) ? field.title : field.label), errors[field.key]);
    }
  };

  const _validator = (form, validateFields) => {
    const errors = validator && isFunction(validator) ? validator(form) : {};
    if (!isEmpty(validateFields)) {
      each(validateFields, field => {
        if (isArray(field)) {
          each(field, innerField => {
            __validator(form, innerField, errors);
          });
        } else {
          __validator(form, field, errors);
        }
      });
    }
    return errors;
  };

  const handleSubmit = (event) => {
    if (event) event.preventDefault();
    setIsHandleSubmit(true);
    setIsSubmitting(true);
  };


  const getIsError = (errors) => {
    let isError = false;
    each(errors, error => {
      if (!isError) {
        isError = !isEmpty(error);
      }
    });
    return isError;
  };

  useEffect(() => {
    setIsError(getIsError(errors));
  }, [errors]);

  useEffect(() => {
    if (isSubmitting) {
      const _errors = _validator(form, validateFields);
      setErrors(_errors);

      setIsSubmit(true);
      if (!getIsError(_errors)) {
        const _form = {};
        each(form, (value, key) => {
          const field = getFieldByKey(validateFields, key);
          if (field && field.validators) {
            value = restore(value, field.validators);
          }
          _form[key] = value;
        });

        if (isHandleSubmit && isTestCompany()) {
          testMsg();
        } else {
          if (submit) {
            submit(_form);
          } else {
            onSubmit(_form);
          }
        }
        setIsSubmit(false);
      }
      setIsHandleSubmit(false);
      setIsSubmitting(false);
    }
  }, [isSubmitting, validateFields]);


  const resetForm = useCallback((_form) => {
    setIsSubmit(false);
    setErrors({});
    const targetForm = _form || originForm;
    if (_form) {
      setOriginForm(_form);
    }
    if (!isEqual(targetForm, form)) {
      setForm(targetForm);
    }
  }, [form, initForm]);

  useEffect(() => {
    if (isSubmit) {
      setErrors(_validator(form, validateFields));
    }
  }, [form, validateFields]);
  const _reset = () => {
    setSelectedList([]);
    setTotal(0);
    setIsLoading(true);
  };

  const setPage = (page) => {
    _reset();
    _setForm({
      ...form,
      page: page || 0,
    });
    setIsSubmitting(true);
  };
  const setLimit = (limit) => {
    _reset();
    _setForm({
      ...form,
      page: 0,
      limit: limit || 10
    });
    setIsSubmitting(true);
  };

  const filterSubmit = (params) => {
    if (params && params.preventDefault) params.preventDefault();
    _reset();
    _setForm({
      ...form,
      ...params && params.params ? params.params : {},
      page: originForm.page || 0,
      limit: originForm.limit || 10
    });
    setIsSubmitting(true);
  };

  const setOrderBy = (params) => {
    const { key, order } = params;
    _setForm({
      ...form,
      order: [
        { [key]: order }
      ]
    });
    setIsSubmitting(true);
  };

  const reSubmit = () => {
    setIsSubmitting(true);
  };

  return {
    form, // form
    values: form, // 상동
    setAllForm: setForm, // form 전체를 다시 설정함 orifin 은 바뀌지 않음
    setForm: _setForm, // form Assign setIn 함
    setValues: _setForm, // 상동
    setInForm, // form 의 특정 대상 수정.
    errors, // error 목록
    setErrors, // error setting
    handleOnChange, // 실시간 change
    handleSubmit, // 실행 액션
    resetForm, // 기본 form 으로 reset
    reset: resetForm, // 상동
    originForm, // 기본 form
    setOriginForm, // 기본 form 세팅
    setSubmit, // submit 변경?
    isSubmit, // submit 실행 한적 있는지?
    isError, // error 가 있는지 없는지
    setIsError,
    validateFields, // validate용 fields
    setValidateFields, // set validate용 fields
    reSubmit, // submit 똑같이 다시 호출

    // list 용 
    filterSubmit, // 필터 실행 함수
    list,
    setList,
    selectedList,
    setSelectedList, // checkbox 용
    selectedData,
    setSelectedData, // radio 용
    isLoading,
    setIsLoading,
    total,
    setTotal,
    page: form.page || 0,
    setPage,
    limit: form.limit || 0,
    setLimit,
    setOrderBy,
  };
};

export default useForm;